import React, { useState } from "react";
import { Search } from "lucide-react";
import { useNavigate } from "react-router-dom";
import heroBg from "../../../../assets/hero_bg.png";

const HeroSection: React.FC = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  const handleExplore = () => {
    // Navigate to explore/search results
    navigate("/explore");
  };

  return (
    <div className="">
      <div
        className="relative w-full h-[700px] bg-cover bg-center bg-no-repeat flex items-center rounded-b-[32px] overflow-hidden"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        {/* Content */}
        <div className="relative z-10 w-full px-4 sm:px-8 lg:px-16 xl:px-24 py-20">
          <div className="max-w-4xl">
            {/* Main Heading */}
            <h1
              className="text-white mb-6 font-bold capitalize
             text-[40px] sm:text-[50px] md:text-[60px] leading-[48px] sm:leading-[58px] md:leading-[68px]"
              style={{ fontFamily: "Poppins" }}
            >
              Discover Smarter, Safer,
              <br />
              And Greener Camping
            </h1>

            <div className="mb-8">
              <span
                className="text-white font-normal capitalize
               text-[22px] sm:text-[28px] md:text-[36px] leading-[36px] sm:leading-[48px] md:leading-[60px]"
                style={{ fontFamily: "Poppins" }}
              >
                Explore Nature In Real Time —{" "}
              </span>
              <span
                className="text-white font-bold capitalize text-[22px] sm:text-[28px] md:text-[36px] leading-[36px] sm:leading-[48px] md:leading-[60px] px-2"
                style={{
                  fontFamily: "Poppins",
                  color: "#A3D4F1",
                }}
              >
                Powered By AI.
              </span>
            </div>

            {/* Description */}
            <p
              className="text-white mb-10 max-w-2xl"
              style={{
                fontFamily: "Inter",
                fontWeight: 500,
                fontSize: "16px",
                lineHeight: "24px",
              }}
            >
              Discover the perfect camping experience with our curated selection
              of premium campsites. From serene wilderness retreats to
              family-friendly locations, find your ideal outdoor escape.
            </p>

            {/* Search Bar */}
            <div className="flex flex-col sm:flex-row gap-4 max-w-2xl">
              <div className="relative flex-1">
                <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                <input
                  type="text"
                  placeholder="Search Campsites, Region or Keyword"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full pl-12 pr-4 py-4 rounded-full text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-400 bg-white"
                  style={{
                    fontFamily: "Inter",
                    fontSize: "16px",
                  }}
                />
              </div>
              <button
                onClick={handleExplore}
                className="px-8 py-4 rounded-full text-white font-medium transition-all hover:opacity-90"
                style={{
                  backgroundColor: "#60A5FA",
                  fontFamily: "Poppins",
                  fontWeight: 500,
                  fontSize: "16px",
                }}
              >
                <span className="text-black">Explore Now</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
